module.exports = __webpack_public_path__ + "img/user-color.4994bf10.svg";